import { forwardRef, useContext, type ComponentRef } from "react";

import { Typography } from "../../atoms/typography";
import { DialogTitlePrimitive } from "../../primitives";
import { DialogHeaderAlignContext } from "./lib";
import type { DialogTitleProps } from "./types";

/**
 * Dialog.Title
 *
 * Wired to `aria-labelledby` on the dialog content. Renders a Typography
 * `label-md` in the default foreground color via Radix/RNR's `asChild`
 * mechanism so the heading semantics stay with the primitive. Centred in a
 * centred Header.
 */
export const DialogTitle = forwardRef<ComponentRef<typeof DialogTitlePrimitive>, DialogTitleProps>(
  ({ children, className }, ref) => {
    const align = useContext(DialogHeaderAlignContext);
    return (
      <DialogTitlePrimitive ref={ref} asChild>
        <Typography
          variant="label-md"
          color="neutral-foreground-default"
          align={align === "center" ? "center" : undefined}
          className={className}
        >
          {children}
        </Typography>
      </DialogTitlePrimitive>
    );
  },
);

DialogTitle.displayName = "Dialog.Title";
